import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// ANTI-CACHE: Aggressively unregister any rogue service workers on localhost
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log('Unregistered rogue service worker.');
    }
  });
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
